import styled from 'styled-components';

import { PanelWrapper } from 'libs/ui';

export const Content = styled(PanelWrapper)`
  margin-top: 36px;
`;
